var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenSaveDebug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_37",
    "data-name": "\\uADF8\\uB8F9 37",
    transform: "translate(-211 -386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_30",
    "data-name": "\\uD0C0\\uC6D0 30",
    transform: "translate(211 386)",
    fill: "rgba(17,17,53,0.45)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_35",
    "data-name": "\\uADF8\\uB8F9 35",
    transform: "translate(-71.5 -8.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uBE7C\\uAE30_21",
    "data-name": "\\uBE7C\\uAE30 21",
    transform: "translate(4284 2727.461)",
    fill: "#4b0d0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3969.5 -2274.790771484375 C -3969.970458984375 -2274.991943359375 -3970.43505859375 -2275.229248046875 -3970.887939453125 -2275.5 C -3972.5546875 -2276.497802734375 -3974.054443359375 -2277.9287109375 -3975.344970703125 -2279.753662109375 C -3978.024658203125 -2283.541748046875 -3979.500244140625 -2288.58740234375 -3979.500244140625 -2293.961181640625 C -3979.500244140625 -2301.08056640625 -3976.859375 -2307.62109375 -3972.572021484375 -2311.216552734375 C -3971.193359375 -2308.611328125 -3968.48388671875 -2306.960693359375 -3965.5 -2306.960693359375 C -3962.51611328125 -2306.960693359375 -3959.806640625 -2308.611083984375 -3958.42822265625 -2311.216552734375 C -3954.140625 -2307.62158203125 -3951.499755859375 -2301.0810546875 -3951.499755859375 -2293.961181640625 C -3951.499755859375 -2288.58740234375 -3952.975341796875 -2283.541748046875 -3955.655029296875 -2279.753662109375 C -3956.9453125 -2277.9287109375 -3958.445068359375 -2276.497802734375 -3960.1123046875 -2275.5 C -3960.240234375 -2275.42333984375 -3960.36962890625 -2275.34912109375 -3960.500244140625 -2275.277587890625 L -3960.500244140625 -2300.460693359375 L -3960.500244140625 -2300.960693359375 L -3961.000244140625 -2300.960693359375 L -3969 -2300.960693359375 L -3969.5 -2300.960693359375 L -3969.5 -2300.460693359375 L -3969.5 -2274.790771484375 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -3970 -2275.578369140625 L -3970 -2301.460693359375 L -3960.000244140625 -2301.460693359375 L -3960.000244140625 -2276.158935546875 C -3958.539794921875 -2277.1064453125 -3957.216796875 -2278.410888671875 -3956.063232421875 -2280.042236328125 C -3953.44287109375 -2283.746826171875 -3951.999755859375 -2288.68994140625 -3951.999755859375 -2293.961181640625 C -3951.999755859375 -2300.68310546875 -3954.388427734375 -2306.8662109375 -3958.299560546875 -2310.439697265625 C -3959.838134765625 -2307.9873046875 -3962.542236328125 -2306.460693359375 -3965.5 -2306.460693359375 C -3968.45751953125 -2306.460693359375 -3971.16162109375 -2307.9873046875 -3972.700439453125 -2310.439697265625 C -3976.611572265625 -2306.86572265625 -3979.000244140625 -2300.6826171875 -3979.000244140625 -2293.961181640625 C -3979.000244140625 -2288.68994140625 -3977.55712890625 -2283.746826171875 -3974.936767578125 -2280.042236328125 C -3973.6865234375 -2278.274658203125 -3972.23779296875 -2276.890869140625 -3970.631103515625 -2275.92919921875 C -3970.423095703125 -2275.8046875 -3970.21240234375 -2275.687744140625 -3970 -2275.578369140625 M -3969 -2274.06005859375 L -3969.001220703125 -2274.060546875 C -3969.729248046875 -2274.31591796875 -3970.450439453125 -2274.65576171875 -3971.14453125 -2275.071044921875 C -3972.871337890625 -2276.1044921875 -3974.421875 -2277.58251953125 -3975.753173828125 -2279.46484375 C -3978.491943359375 -2283.336669921875 -3980.000244140625 -2288.48486328125 -3980.000244140625 -2293.961181640625 C -3980.000244140625 -2301.49658203125 -3977.08544921875 -2308.40869140625 -3972.393310546875 -2312.00048828125 C -3971.20751953125 -2309.242431640625 -3968.502197265625 -2307.460693359375 -3965.5 -2307.460693359375 C -3962.498046875 -2307.460693359375 -3959.792236328125 -2309.24267578125 -3958.60693359375 -2312.00048828125 C -3953.9140625 -2308.408935546875 -3950.999755859375 -2301.49658203125 -3950.999755859375 -2293.961181640625 C -3950.999755859375 -2288.48486328125 -3952.508056640625 -2283.336669921875 -3955.246826171875 -2279.46484375 C -3956.577880859375 -2277.58251953125 -3958.12841796875 -2276.1044921875 -3959.85546875 -2275.071044921875 C -3960.228515625 -2274.84765625 -3960.61376953125 -2274.64404296875 -3961.000244140625 -2274.4658203125 L -3961.000244140625 -2300.460693359375 L -3969 -2300.460693359375 L -3969 -2274.06005859375 Z",
    stroke: "none",
    fill: "#960c0c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uBE7C\\uAE30_22",
    "data-name": "\\uBE7C\\uAE30 22",
    transform: "translate(4291 2720)",
    fill: "#960c0c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3965.570556640625 -2305.50048828125 L -3979.429443359375 -2305.50048828125 C -3979.20556640625 -2307.06591796875 -3978.458740234375 -2308.506591796875 -3977.293212890625 -2309.60205078125 C -3975.99072265625 -2310.826171875 -3974.288330078125 -2311.50048828125 -3972.5 -2311.50048828125 C -3970.711669921875 -2311.50048828125 -3969.00927734375 -2310.826171875 -3967.706787109375 -2309.60205078125 C -3966.541259765625 -2308.506591796875 -3965.79443359375 -2307.06591796875 -3965.570556640625 -2305.50048828125 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -3966.17333984375 -2306.00048828125 C -3966.4638671875 -2307.231689453125 -3967.110107421875 -2308.355224609375 -3968.049072265625 -2309.237548828125 C -3969.2587890625 -2310.37451171875 -3970.83935546875 -2311.00048828125 -3972.5 -2311.00048828125 C -3974.16064453125 -2311.00048828125 -3975.7412109375 -2310.37451171875 -3976.95068359375 -2309.237548828125 C -3977.889892578125 -2308.355224609375 -3978.5361328125 -2307.231689453125 -3978.82666015625 -2306.00048828125 L -3966.17333984375 -2306.00048828125 M -3965.01611328125 -2305.00048828125 L -3979.98388671875 -2305.00048828125 C -3979.85888671875 -2306.89794921875 -3979.0244140625 -2308.6611328125 -3977.635498046875 -2309.96630859375 C -3976.239990234375 -2311.278076171875 -3974.416015625 -2312.00048828125 -3972.5 -2312.00048828125 C -3970.583984375 -2312.00048828125 -3968.760009765625 -2311.278076171875 -3967.3642578125 -2309.96630859375 C -3965.975341796875 -2308.660888671875 -3965.141357421875 -2306.897705078125 -3965.01611328125 -2305.00146484375 L -3965.01611328125 -2305.00048828125 Z",
    stroke: "none",
    fill: "#4b0d0d"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_22",
    "data-name": "\\uC120 22",
    x2: 3,
    y2: 3,
    transform: "translate(311.5 407.5)",
    fill: "none",
    stroke: "#960c0c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_23",
    "data-name": "\\uC120 23",
    x1: 2.484,
    y2: 3,
    transform: "translate(323.5 407.5)",
    fill: "none",
    stroke: "#960c0c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_24",
    "data-name": "\\uC120 24",
    x1: 5,
    transform: "translate(329.5 420.5)",
    fill: "none",
    stroke: "#960c0c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_25",
    "data-name": "\\uC120 25",
    x1: 5,
    transform: "translate(302.5 420.5)",
    fill: "none",
    stroke: "#960c0c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_26",
    "data-name": "\\uC120 26",
    x1: 4.5,
    y2: 4,
    transform: "translate(299.5 432.5)",
    fill: "none",
    stroke: "#960c0c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_27",
    "data-name": "\\uC120 27",
    x2: 4.5,
    y2: 4,
    transform: "translate(333 432.5)",
    fill: "none",
    stroke: "#960c0c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_28",
    "data-name": "\\uC120 28",
    x2: 3,
    y2: 7.099,
    transform: "translate(329.5 446.401)",
    fill: "none",
    stroke: "#960c0c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_29",
    "data-name": "\\uC120 29",
    x1: 3,
    y2: 7.099,
    transform: "translate(304.5 446.401)",
    fill: "none",
    stroke: "#960c0c",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(258 407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_148",
    "data-name": "\\uC0AC\\uAC01\\uD615 148",
    width: 22,
    height: 22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons",
    transform: "translate(0.931 4.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_36",
    "data-name": "\\uADF8\\uB8F9 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_105",
    "data-name": "\\uD328\\uC2A4 105",
    d: "M8.406,10.839h12V20.957h-12L4.128,15.9l4.277-5.059M7.762,9a.414.414,0,0,0-.368.184L2.2,15.346a.966.966,0,0,0,0,1.1l5.2,6.163a.414.414,0,0,0,.368.184H21.329a.92.92,0,0,0,.92-.92V9.919a.92.92,0,0,0-.92-.92Z",
    transform: "translate(-2.023 -8.999)",
    fill: "#4c7c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_106",
    "data-name": "\\uD328\\uC2A4 106",
    d: "M24.508,20.2l1.656-1.61a.966.966,0,0,0,.092-1.242.874.874,0,0,0-1.38-.092L23.22,18.91l-1.656-1.656a.874.874,0,0,0-1.38.092.966.966,0,0,0,.092,1.242l1.656,1.61-1.656,1.61a.966.966,0,0,0-.092,1.242.874.874,0,0,0,1.38.092l1.656-1.656,1.656,1.656a.874.874,0,0,0,1.38-.092.966.966,0,0,0-.092-1.242Z",
    transform: "translate(-11.733 -13.298)",
    fill: "#4c7c57"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenSaveDebug);
export default __webpack_public_path__ + "static/media/ben_save_debug.d2e93743678555cf53736c2f59414ea3.svg";
export { ForwardRef as ReactComponent };